import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import store from "../../../app/store";

const _authToken = () => {
  const state = store.getState();
  return `${state?.authReducer?.userData?.tokenType?.toLowerCase()} ${
    state?.authReducer?.userData?.token
  }`;
};
const _orgClientId = () => {
  const state = store.getState();
  return state?.orgReducer?.selectedFI?.orgClientId
    ? state?.orgReducer?.selectedFI?.orgClientId
    : state?.authReducer?.userData?.client_Id;
};

// ---------------------------------------------------------
// RTK Query API
// ---------------------------------------------------------
export const notificationSlice = createApi({
  reducerPath: "notificationApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["Notification"],
  endpoints: (builder) => ({
    // ----------------------------------------
    // GET NOTIFICATION LIST
    // ----------------------------------------
    getNotificationList: builder.query({
      query: () => ({
        url: `/${_orgClientId()}/notification`,
        method: "GET",
        headers: {
          Authorization: _authToken(),
          "Content-Type": "application/json",
        },
      }),
      providesTags: ["Notification"],
    }),
    // ----------------------------------------
    // READ ALL NOTIFICATIONS (PUT)
    // ----------------------------------------
    readAllNotificationList: builder.mutation({
      query: ({ payloadObject }) => ({
        url: `/${_orgClientId()}/notification`,
        method: "PUT",
        headers: {
          Authorization: _authToken(),
          "Content-Type": "application/json",
        },
        body: payloadObject,
      }),
      invalidatesTags: ["Notification"], // auto refetch list
    }),
  }),
});

export const {
  useGetNotificationListQuery,
  useLazyGetNotificationListQuery,
  useReadAllNotificationListMutation,
} = notificationSlice;
